import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTimes, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import filterTypes from "data/filter-types";
import { Popconfirm } from "antd";
import { closeCustomModal, openCustomModal } from "views/lib/components/modals";
import { messageDelete, messageGetSearch } from "actions/message/requests";
import { moduleGetSearch } from "actions/module/requests";
import TranslationFilters from "views/pages/Translation/filters";
import MessagesModal from "./MessagesModal";
import CommonTable from "../../lib/components/CommonTable";

const filterFields = (selectObjects = {}) => ({
  id: {
    placeholder: "ID",
    filterType: "text",
    defaultValue: "",
    searchOperation: [filterTypes.LIKE.value]
  },
  description: {
    placeholder: "Description",
    filterType: "text",
    defaultValue: "",
    searchOperation: [filterTypes.LIKE.value]
  },
  module: {
    placeholder: "Module",
    filterType: "select",
    defaultValue: "",
    filterTypeOptions: selectObjects.module || [],
    searchOperation: [filterTypes.EQUALS.value]
  },
});

const Translation = ({
                       messageGetSearch,
                       messageDelete,
                       messageList,
                       loading,
                       moduleGetSearch,
                       moduleList,
                       ...rest
                     }) => {
  const {
    openCustomModal,
    closeCustomModal
  } = rest;

  const handleDelete = id => {
    messageDelete(id);
  };

  const handleView = (ev, messageId, module) => {
    ev.preventDefault();

    const modalObj = {
      modalSettings: {
        size: "lg"
      },
      header: false,
      children: (
        <MessagesModal
          messageId={messageId}
          module={module}
          onSuccess={() => closeCustomModal(modalObj)}
        />
      ),
      handleClose: () => closeCustomModal(modalObj)
    };
    openCustomModal(modalObj);
  };

  const getColumns = () => [
    {
      id: "id",
      Header: "ID",
      accessor: "id",
    },
    {
      id: "description",
      Header: "Description",
      accessor: "description",
    },
    {
      id: "module",
      Header: "Module",
      accessor: "module",
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <React.Fragment>
          <button
            className="btn btn-sm mx-2 btn-success"
            onClick={ev => handleView(ev, original.id, original.module)}
          >
            <FontAwesomeIcon icon={faEye}/>
          </button>
          <Link to={`/translation/edit/${original.id}`} className="btn btn-sm mx-2 btn-warning">
            <FontAwesomeIcon icon={faPencilAlt}/>
          </Link>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => handleDelete(original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm mx-2 btn-danger">
              <FontAwesomeIcon icon={faTimes}/>
            </button>
          </Popconfirm>
        </React.Fragment>
      )
    },
  ];

  useEffect(() => {
    if (!moduleList.length) {
      moduleGetSearch(0, 10000);
    }
  }, [moduleGetSearch, moduleList]);


  return (
    <CommonTable
      columns={getColumns()}
      list={messageList}
      getListFunction={messageGetSearch}
      FiltersComponent={(filterProps) => (
        <TranslationFilters {...filterProps} fields={filterFields({
          module: moduleList.map(item => ({
            value: item.id,
            label: item.id
          }))
        })}
        />
      )}
      searchHookProps={{
        size: 20,
        sort: "id,asc"
      }}
    />
  );
};

const mapStateToProps = state => ({
  loading: state.message.loading,
  messageList: state.message.list,
  moduleList: state.module.list.content
});

const mapStateToDispatch = dispatch => ({
  messageGetSearch: bindActionCreators(messageGetSearch, dispatch),
  messageDelete: bindActionCreators(messageDelete, dispatch),
  moduleGetSearch: bindActionCreators(moduleGetSearch, dispatch),
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Translation);



// WEBPACK FOOTER //
// ./src/views/pages/Translation/index.js